<div class="container">
  <div class="heading-container">
    <p class="heading" i18n>Sample:{{ data.sampleName }}</p>
    <button class="close-btn" (click)="closePopup()" aria-label="Close dialog">×</button>
  </div>
  <div class="list-container">
    <div *ngFor="let analysis of analysisList">
      <app-analysis-list-item [analysis]="analysis" />
    </div>
  </div>
</div>
